import React from "react";
import { View} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";

  
export default function MainContainer({children,...otherProps}){
    const styles = useStyles();
    return(
        <View style={otherProps.isCustInfo  ? styles.mainContainerHeight :[styles.mainContainer,{height:otherProps.height ? otherProps.height : styles.mainContainer.height,marginTop:otherProps.marginTop ? 0 : 20,paddingBottom:otherProps.paddingBottom ? otherProps.paddingBottom : null,paddingTop:otherProps.paddingTop ? otherProps.paddingTop : null }]}>{children}</View>
    )
}

const useStyles = CreateResponsiveStyle(
    {
        mainContainer : {
            backgroundColor : "#fff",
            height: 510,
            marginLeft: 20,
            marginTop : 20,
            borderRadius: 12,
            width: "98%",
            
        },
        mainContainerHeight : {
            backgroundColor : "#fff",
            height: 1333,
            marginLeft: 20,
            marginTop : 20,
            borderRadius: 12
        }
    },
    {
        [DEVICE_SIZES.LG]: {
        

        },
        [DEVICE_SIZES.MD]: {
            mainContainer :{
                height:"auto",
            }
        },
        [DEVICE_SIZES.SM]: {
            
        },
        [DEVICE_SIZES.XS]: {
            mainContainer :{
                height:1000,
                marginLeft:16,
                width:'93%'
            }
        }
    }
)
